import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { ILoginResponse, UserDetailProfile } from "src/models/UserModels";

@Injectable({
  providedIn: "root",
})
export class UserAuthService {
  constructor(private http: HttpClient, private router: Router) {}

  set accessToken(token: string) {
    localStorage.setItem("authToken", token);
  }

  get accessToken(): string {
    return localStorage.getItem("authToken") ?? "";
  }

  set userGroups(groups: Array<string>) {
    localStorage.setItem("userGroups", JSON.stringify(groups));
  }

  get userGroups(): Array<string> {
    return JSON.parse(localStorage.getItem("userGroups") ?? "[]");
  }

  hasAnyGroup(groups: Array<string>): boolean {
    for (let group of groups) {
      if (this.userGroups.includes(group)) {
        return true;
      }
    }
    return false;
  }

  login(data: any): Observable<ILoginResponse> {
    const url = `${environment.baseUrl}apis/users/staff/v1/login/`;
    const httpOptions = {};
    return this.http.post<ILoginResponse>(url, data, httpOptions);
  }

  requestOtp(payload: { email?: string; mobile_number?: string }): Observable<any> {
    const url = `${environment.baseUrl}apis/users/staff/v1/generate-login-otp/`;
    return this.http.post<any>(url, payload);
  }

  verifyOtp(payload: { email?: string; mobile_number?: string; otp: string }): Observable<ILoginResponse> {
    const url = `${environment.baseUrl}apis/users/staff/v1/login-otp/`;
    return this.http.post<ILoginResponse>(url, {
      ...payload,
      platform: "web",
      version: "1.0.0",
    });
  }

  logout() {
    console.log("In logout");
    localStorage.clear();
    this.router.navigate(["login"]);
  }

  check(): Observable<boolean> {
    if (this.accessToken) {
      return of(true);
    } else {
      return of(false);
    }
  }

  fetchProfileDetails(): Observable<UserDetailProfile> {
    const token = `Token ${localStorage.getItem("authToken")}`;
    const url = `${environment.baseUrl}apis/users/v3/details/?platform=WEB&version=1.1.1`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    };
    return this.http.get<UserDetailProfile>(url, httpOptions);
  }
}
